// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import axios from "axios"
import Antd from "ant-design-vue"
import Vuelidate from "vuelidate"
import mixin from "./mixins/mixin"
import VueSocialSharing from "vue-social-sharing"
import moment from "moment"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faArrowCircleDown, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import {
  faPowerOff,
  faArrowLeft,
  faCheckCircle,
  faArrowRight,
  faEllipsisV,
  faPlusSquare,
  faTimes as faTimesR,
  faPlus as faPlusR,
  faStore,
  faSyncAlt,
  faRepeat,
} from "@fortawesome/pro-regular-svg-icons"
import {
  faCamera,
  faStar as faStarS,
  faCrown,
  faChevronLeft,
  faCheck as faCheckS,
  faTimes,
  faBadgeCheck,
  faPlus,
  faTrash,
  faArrowCircleRight,
  faUser,
  faHandshakeAlt,
  faBell,
  faBars,
  faPen,
  faTimesCircle,
  faHeartCircle,
  faBriefcaseMedical as faBriefcaseMedicalS,
  faCheckCircle as faCheckCircleS,
  faCalendarEdit,
  faExclamationTriangle,
  faBookmark as faBookmarkS,
} from "@fortawesome/pro-solid-svg-icons"
import {
  faCommentAltSmile,
  faWindowMaximize,
  faUserPlus,
  faExchangeAlt,
  faUserMd,
  faQuestionCircle,
  faDrawCircle,
  faBookOpen,
  faBriefcaseMedical,
  faBriefcase,
  faBookmark,
  faCommentAlt,
  faFlagAlt,
  faFlag,
  faSmile,
  faHeart,
  faReply,
  faShareAlt,
  faPhoneAlt,
  faPhone,
  faMapMarkerAlt,
  faHospitalAlt,
  faHospital,
  faHandHoldingHeart,
  faHospitalSymbol,
  faHandsHeart,
  faSearch,
  faNewspaper,
  faCalendar,
  faExchange,
  faTag,
  faImage,
  faImages,
  faPoll,
  faClinicMedical,
  faBullhorn,
  faHandHeart,
  faUserNurse,
  faThumbsUp,
  faThumbsDown,
  faPills,
  faTimes as faTimesL,
  faVideo,
  faBars as faBarsL,
  faStar as faStarL,
  faCheck as faCheckL,
  faCommentAltSlash,
} from "@fortawesome/pro-light-svg-icons"
import { faFacebookF, faGoogle, faLinkedin } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
// import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag"

library.add(
  faPen,
  faTimesL,
  faArrowRight,
  faArrowCircleDown,
  faUserNurse,
  faHandHeart,
  faBullhorn,
  faClinicMedical,
  faPowerOff,
  faExchange,
  faTrash,
  faPoll,
  faImage,
  faImages,
  faSmile,
  faBars,
  faBarsL,
  faCheckCircle,
  faCheckCircleS,
  faCamera,
  faCalendar,
  faCalendarEdit,
  faWindowMaximize,
  faUserPlus,
  faTag,
  faPlus,
  faPlusR,
  faDrawCircle,
  faUser,
  faHandshakeAlt,
  faExchangeAlt,
  faUserMd,
  faQuestionCircle,
  faBookOpen,
  faArrowLeft,
  faBriefcase,
  faBriefcaseMedical,
  faBriefcaseMedicalS,
  faBell,
  faBookmark,
  faBookmarkS,
  faCommentAlt,
  faFlagAlt,
  faFlag,
  faHeart,
  faReply,
  faShareAlt,
  faStarS,
  faStarL,
  faCrown,
  faPhone,
  faPhoneAlt,
  faMapMarkerAlt,
  faHospitalAlt,
  faHospital,
  faHandHoldingHeart,
  faHospitalSymbol,
  faChevronLeft,
  faHandsHeart,
  faFacebookF,
  faGoogle,
  faLinkedin,
  faTimes,
  faTimesR,
  faCheckS,
  faCheckL,
  faBadgeCheck,
  faSearch,
  faCommentAltSmile,
  faArrowCircleRight,
  faThumbsUp,
  faNewspaper,
  faThumbsDown,
  faPills,
  faEllipsisV,
  faPlusSquare,
  faTimesCircle,
  faHeartCircle,
  faVideo,
  faEyeSlash,
  faStore,
  faSyncAlt,
  faExclamationTriangle,
  faRepeat,
  faCommentAltSlash
)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.moment = moment
Vue.prototype.$log = console.log
Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.mixin(mixin)
Vue.use(Vuelidate)
Vue.use(Antd)
Vue.use(VueSocialSharing)
Vue.use(VueGtag, { config: { id: "G-HJTR7B1FKL" } }, router)

export const eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,

  components: { App },
  template: "<App/>",
})



// WEBPACK FOOTER //
// ./src/main.js